import { Link } from 'react-router-dom';
import Heading2 from './Headings';
import Description from './Descriptions';

const courses = [
  {
    title: 'Amazon Selling',
    href: '/amazon-selling',
    description: 'Product research, optimized listings, Seller Central, and Amazon PPC — from first listing to scaling your catalogue.',
    level: 'Up Coming',
    duration: '16 Weeks',
    students: '1 Enrollment',
    image: 'amazon.webp',
  },
  {
    title: 'Prompt Engineering',
    href: '/prompt-engineering',
    description: 'Write prompts that work — from LLM basics to chain-of-thought, roles, templates, and reusable libraries.',
    level: 'Up Coming',
    duration: '4 Weeks',
    students: '1 Enrollment',
    image: 'PromptEngineering.webp',
  },
  {
    title: 'Meta Marketing',
    href: '/meta-marketing',
    description: 'Plan, launch, and optimize Facebook and Instagram ads in Meta Ads Manager — targeting, creatives, and data.',
    level: 'Up Coming',
    duration: '16 Weeks',
    students: '4 Enrollments',
    image: 'Metamarketing.webp',
  },
  {
    title: 'Quality Assurance',
    href: '/quality-assurance',
    description: 'Manual testing, automation, and bug reporting — from SDLC basics to a portfolio employers notice.',
    level: 'Up Coming',
    duration: '16 Weeks',
    students: '2 Enrollments',
    image: 'Qualityassurance.webp',
  },
  {
    title: 'English Level 1',
    href: '/english-level-one',
    description: 'Speaking, listening, and reading for absolute beginners — real conversations, clear steps, daily confidence.',
    level: 'For Beginners',
    duration: '16 Weeks',
    students: '12 students',
    image: 'Englishlevelone.png',
  },
  {
    title: 'English Level 2',
    href: '/english-level-two',
    description: 'Accent, pronunciation, and fluent speaking — move from basic English to confident, natural conversation.',
    level: 'Up Coming',
    duration: '16 Weeks',
    students: '1 Enrollment',
    image: 'Englishleveltwo.webp',
  },
  {
    title: 'Video Editing',
    href: '/video-editing',
    description: 'Learn CapCut, Premiere Pro, and AI video tools — from cutting and grading to export for every platform.',
    level: 'All levels',
    duration: '16 Weeks',
    students: '10 students',
    image: 'VideoEditing.png',
  },
  {
    title: 'UI/UX Design',
    href: '/uiux',
    description: 'Learn to create user-centered interfaces using Figma, wire framing, prototyping, and design principles.',
    level: 'All levels',
    duration: '16 Weeks',
    students: '6+ students',
    image: 'uiux.png',
  },
  {
    title: 'MERN Stack Development',
    href: '/website',
    description: 'Master MongoDB, Express, React, and Node.js to build full-stack web applications.',
    level: 'All levels',
    duration: '16 Weeks',
    students: '10 students',
    image: 'Website.png',
  },
  {
    title: 'SEO & Digital Growth',
    href: '/seo',
    description: 'Learn search engine optimization and digital marketing strategies to grow your online presence.',
    level: 'All levels',
    duration: '16 Weeks',
    students: '10 students',
    image: 'SEO.png',
  },
  {
    title: 'Python Programming',
    href: '/python',
    description: 'From basics to advanced: build automation, data science, and web development skills.',
    level: 'All levels',
    duration: '16 Weeks',
    students: '12 students',
    image: 'python.png',
  },
];

const CourseCard = ({ title, description, level, duration, students, image, href }) => (
  <div className="bg-white rounded-xl overflow-hidden border border-[#DBE2E7] flex flex-col">
    <div className="h-40 bg-[#D3DBE0] overflow-hidden rounded-t-xl">
      <img
        src={`${process.env.PUBLIC_URL}/images/${image}`}
        alt={title}
        className="w-full h-full object-cover"
      />
    </div>
    <div className="p-5 sm:p-6 flex flex-col gap-3 flex-1">
      <div className="flex justify-between items-center gap-3 flex-wrap">
        <div className="flex gap-2 flex-wrap">
          <span
            className="px-3 py-1 rounded-md text-xs font-medium border border-[#B7D2FF] text-[#162D66] bg-white"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            {level}
          </span>
          <span
            className="px-3 py-1 rounded-md text-xs font-medium border border-[#B7D2FF] text-[#162D66] bg-white"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            {duration}
          </span>
        </div>
        <span className="flex items-center gap-1.5 text-xs text-[#1f2937]" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#9CA3AF">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
          {students}
        </span>
      </div>
      <h3
        className="text-lg font-semibold text-[#162D66] m-0"
        style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
      >
        {title}
      </h3>
      <p
        className="text-sm font-normal text-[#374151] m-0 flex-1"
        style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em', lineHeight: '1.5' }}
      >
        {description}
      </p>
      {href ? (
        <Link
          to={href}
          className="w-full flex items-center justify-center gap-2 py-2 px-4 rounded-full text-white text-base font-medium no-underline transition-opacity hover:opacity-90"
          style={{
            fontFamily: 'Manrope, sans-serif',
            background: 'linear-gradient(90deg, #2563EB 0%, #3B82F6 100%)',
          }}
        >
          Enroll Now →
        </Link>
      ) : (
        <button
          type="button"
          className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-full text-white text-base font-medium"
          style={{
            fontFamily: 'Manrope, sans-serif',
            background: 'linear-gradient(90deg, #2563EB 0%, #3B82F6 100%)',
          }}
        >
          Enroll Now →
        </button>
      )}
    </div>
  </div>
);

export default function OurCoursesall() {
  return (
    <section
      className="relative overflow-hidden px-4 sm:px-8 lg:px-[80px] py-12 lg:py-16"
      style={{
        background: 'linear-gradient(180deg, rgba(240, 244, 255, 0.9) 0%, rgba(255, 255, 255, 1) 50%, rgba(242, 247, 255, 0.95) 100%)',
      }}
    >
      {/* Background Lines (bgline.svg) - on top of gradient */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden z-[1]">
        <img
          src={`${process.env.PUBLIC_URL}/images/bgline.svg`}
          alt=""
          className="absolute w-[120%] left-[12%] -top-64 h-full object-contain opacity-80"
        />
      </div>

      {/* Content */}
      <div className="relative z-[2] max-w-[1080px] mx-auto">
        <div className="flex flex-col items-center gap-4 mb-12">
          <Heading2>Our Courses</Heading2>
          <Description className="text-center max-w-[500px]">
          From beginners to pros our courses give you the skills the world is looking for.
          </Description>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course, index) => (
            <CourseCard key={index} {...course} />
          ))}
        </div>
      </div>
    </section>
  );
}
